import { useGasPrice } from "@/hooks";
import { parseGwei, formatUnits } from "viem";

interface UseTransactionFeesProps {
    estimatedGas: bigint | null;
}

const ETH_PRICE_USD = 2500; // TODO: Replace with real-time price feed

export function useTransactionFees({ estimatedGas }: UseTransactionFeesProps) {
    const { data: gasPrice, isLoading: isGasPriceLoading } = useGasPrice();

    const slippagePercent = 0.005;

    // Calculate gas cost in ETH
    // Gas price is in Gwei, convert to Wei first
    const gasPriceInWei = gasPrice ? parseGwei(String(gasPrice)) : BigInt(0);
    // Multiply by gas limit to get total gas cost in Wei
    const totalGasInWei = estimatedGas ? gasPriceInWei * estimatedGas : BigInt(0);
    // Convert Wei to ETH
    const totalGasInEth = Number(formatUnits(totalGasInWei, 18));
    // Convert to USD with 2 decimal places
    const gasPriceUSD = (totalGasInEth * ETH_PRICE_USD).toFixed(2);

    return {
        gasPriceUSD: gasPriceUSD,
        slippagePercent,
        estimatedGasCost: totalGasInEth,
        isLoading: isGasPriceLoading,
    };
}
